import { Typography } from 'antd';
import React from 'react';

export const Hint = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      style={{
        color: '#999',
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      {children}
    </Typography>
  );
};
